import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4786a68a")

_pushScopeId("data-v-4786a68a")
const _hoisted_1 = { class: "flex flex--valign-c flex--gap-5" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.length, (number, idx) => {
      return (_openBlock(), _createBlock("div", {
        key: number,
        class: ["carousel-dot", { active: idx === _ctx.active }],
        onClick: _withModifiers(($event: any) => (_ctx.$emit('click', idx)), ["stop"])
      }, null, 10, ["onClick"]))
    }), 128))
  ]))
})